import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { OrderService } from '../services/order.service';
import { AlertService } from '../alert';

@Component({
    selector: 'orders',
    providers: [OrderService],
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {

    orders: any[] = [];
    loading = false;
    status = '';
    currentOrder: any = null;
    collapsed:boolean = true;
    orderIndex: number = null;
    scans: any[];

    constructor(
        private router: Router,
        private orderService: OrderService,
        private alertService: AlertService) {
    }

    ngOnInit() {
        this.getOrders('READY');
    }

    getOrders(filter: string) {
        this.loading = true;
        this.status = filter;
        this.orderService.getOrders(filter)
            .subscribe(
            data => {
                this.orders=data;
                this.currentOrder = null;
                this.loading = false;
                this.alertService.clear();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }

    select(event) {
        if (this.status =='READY') {
            this.orderService.updateStatus(event.reference, 'SCAN')
                .subscribe(
                  data => {this.status = 'SCAN';
                  this.router.navigate(['/order', event.reference]);
                });
        } else {
          this.router.navigate(['/order', event.reference]);
        }
    }

    selectCurrentOrder(event) {
        this.collapsed = !this.collapsed;
        if (!this.collapsed) {
            this.orderService.getOrder(event.reference)
                .subscribe(
                    data => {
                    this.currentOrder = data;
                    let i = 0;
                    for (let item of this.orders) {
                        if (item.reference == event.reference) {
                            this.orderIndex = i;
                            break;
                        }
                        i = i+1;
                    }
                    this.getScans(event.reference);
                    this.alertService.clear();
                },
                error => {
                    this.alertService.error(error);
                    this.currentOrder = null;
                    this.orderIndex= null
                });
        } else {
            this.currentOrder = null;
            this.orderIndex= null;
        }
    }

    getScans(reference: string) {
        this.orderService.getScans(reference)
          .subscribe(
            data => {
              this.scans = data;
              this.alertService.clear();
            },
            error => {
              this.alertService.error(error);
            });
      }

    getScanMenge(position) {
        if (position == null || this.scans == null) {
          return 0;
        }
        for (let i = 0; i < this.scans.length; i++) {
          if (this.scans[i].articleRef == position.articleRef) {
            return this.scans[i].numberOfItems;
          }
        }
        return 0;
      }
    
      isComplete(position) {
        if (position == null || this.scans == null) {
          return false;
        }
        for (let i = 0; i < this.scans.length; i++) {
          if (this.scans[i].articleRef == position.articleRef && this.scans[i].numberOfItems == position.numberOfItems) {
            return true;
          }
        }
        return false;
      }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/orders.component.ts